/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Button, Input } from "../../../components";
import { Calendar } from "react-multi-date-picker";
import { WEEK_DAYS } from "../../../utilities/utils";
import { validatePositiveValue } from "../../../utilities/utils";
import { differenceInCalendarDays } from "date-fns";

const CustomerCoachingBookingStep2 = (props: any) => {
  const {
    sportData,
    sessionData,
    data,
    updateData,
    handleHome,
    handleNext,
    error,
  } = props;

  const [calendarDay, setCalendarDay] = useState<any>([]);

  const handleChecked = (checked: any, slot: any) => {
    checked
      ? data?.selectedSlots?.length < data?.noOfDays &&
      setCalendarDay([...calendarDay, WEEK_DAYS.indexOf(slot.sessionDay)])
      : setCalendarDay(
        calendarDay.filter(
          (elem: any) => WEEK_DAYS.indexOf(slot.sessionDay) !== elem
        )
      );
    checked
      ? data?.selectedSlots?.length < data?.noOfDays &&
      updateData("selectedSlots", [...data.selectedSlots, slot.id])
      : updateData(
        "selectedSlots",
        data.selectedSlots?.filter((item: any) => item !== slot?.id)
      );
  };

  useEffect(() => {
    if (data?.selectedSlots?.length <= data?.noOfDays) {
      let cDays: any = [];
      data?.selectedSlots.map((slots: any) => {
        let day = sessionData.sessionSlots?.find(
          (_day: any) => _day.id === slots
        ).sessionDay;
        cDays.push(WEEK_DAYS.indexOf(day));
      });

      setCalendarDay(cDays);
    }
    return () => {
      setCalendarDay([]);
    };
  }, []);

  const setPositiveValue = (key = "", value = "") => {
    if (validatePositiveValue(value)) {
      updateData(key, isNaN(parseInt(value)) ? "" : parseInt(value));
    }
  };

  let perWeekCharges =
    sessionData?.sessionRates?.find?.(
      (_rate: any) => _rate?.noOfDays === data?.noOfDays
    )?.ratePerSession * data?.noOfDays;


  const isDayDisabled = () => {
    const currentDate = new Date();
    const day = currentDate.getDay();
    const date = currentDate.getDate();
    let AddDays = 0;
    if (day !== 0) {
      AddDays = 7 - day;
    }
    return currentDate.setDate(date + AddDays);
  };

  const getFormatedDate = (_date: string) => {
    if (!_date) {
      return new Date();
    }
    if (_date?.includes?.("GMT")) {
      return new Date(_date);
    }
    const [_dd, _mm, _yy] = _date?.split?.("/") || [];
    return new Date(`${_mm}/${_dd}/${_yy}`);
  };

  return (
    <>
      <Container fluid className="g-0">
        <Row className="row-mb align-items-center">
          <Col lg={12}>
            <h4 className="fs-5 fw-semibold mb-4 text-start">
              {sportData.name}
            </h4>
            <h5 className="d-block fs-5 fw-semibold mb-0 text-start">
              {sessionData.name}{" "}
              <span className="fs-7 fw-semibold ms-2">
                Start Date:{" "}
                <span className="text-info">{sessionData.startDate}</span>
              </span>{" "}
              <span className="fs-7 fw-semibold ms-2">
                End Date:{" "}
                <span className="text-info">{sessionData.endDate}</span>
              </span>
            </h5>
          </Col>
        </Row>
        <div className="available-slot text-start">
          <label htmlFor="selectsession" className="form-label">
            Select the days to attend
          </label>
          <Row className="row-mb text-start position-relative">
            {WEEK_DAYS.map((item: any) => {
              let day = sessionData.sessionSlots?.find(
                (_day: any) => _day.sessionDay === item
              );
              return !day ? (
                <Col key={item}>
                  <Input
                    id={item}
                    type="checkbox"
                    name={item}
                    className="btn-check disabled"
                  />
                  <label
                    htmlFor={item}
                    className="align-items-center bg-white border border-2 btn d-flex disabled h-100 justify-content-center rounded-2"
                  >
                    <div className="slot-days">
                      <span className="d-block fs-6 text-uppercase">
                        {item}
                      </span>
                    </div>
                  </label>
                </Col>
              ) : (
                <Col key={item}>
                  <Input
                    onChange={(e: any) => handleChecked(e.target.checked, day)}
                    checked={
                      data?.selectedSlots?.find((elem: any) => elem === day?.id)
                        ? true
                        : false
                    }
                    id={item}
                    type="checkbox"
                    name={item}
                    className="btn-check"
                    value={day?.id}
                  />
                  <label
                    htmlFor={item}
                    className="align-items-center bg-white border border-2 btn d-flex h-100 justify-content-center rounded-2"
                  >
                    <div className="slot-days">
                      <span className="d-block fs-6 text-uppercase">
                        {day?.sessionDay}
                      </span>
                      <small className="d-block fs-7 text-info">
                        {day?.startTime} - {day?.endTime}
                      </small>
                    </div>
                  </label>
                </Col>
              );
            })}
            <span className="error-msg mt-1 text-center top-100">
              {error?.selectedSlots}
            </span>
          </Row>
        </div>
        <Row>
          <Col lg={5}>
            <div className="mb-4 text-start">
              <label htmlFor="addweek" className="form-label">
                Add weeks for booking <span className="text-danger">*</span>
              </label>
              <Input
                onChange={(e: any) => {
                  setPositiveValue("noOfWeeks", e?.target?.value);
                }}
                value={data?.noOfWeeks}
                type="number"
                name="noOfWeeks"
                id="noOfWeeks"
                min="1"
                className="form-control"
                onKeyDown={(e: any) =>
                  ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                }
                onWheel={(e: any) => e.target.blur()}
              />
              <span className="error-msg">{error?.noOfWeeks}</span>
            </div>
            <div className="details-week text-start ">
              <span className="d-block fs-6">
                Minimum Week to Enroll: {sessionData?.minWeeksToBook} week
              </span>
              <span className="d-block fs-6">
                Weekly Charges: <span className="rupees-symbol">&#8377;</span>
                {perWeekCharges?.toFixed(2) || ""}
              </span>
              {sessionData?.sessionOffers?.map?.((_offer: any) => (
                <span className="d-block fs-6" key={_offer?.id}>
                  {_offer?.noOfWeeks} Weeks Charges{" "}
                  <span className="text-primary">
                    ({_offer?.discountPercent}% off)
                  </span>

                </span>
              ))}
            </div>
          </Col>
          <Col lg={3}>
            <div className="text-start mb-3">
              <label htmlFor="" className="form-label">
                Select Start date <span className="text-danger">*</span>
              </label>
              <Calendar
                mapDays={({ date }) => {
                  let isDisable = !calendarDay.includes(date.weekDay.index);
                  if (isDisable)
                    return {
                      disabled: true,
                      style: { color: "#ccc" },
                    };
                }}
                format="DD/MM/YYYY"
                onChange={(date: any) => {
                  updateData("startDate", date?.toDate().toUTCString());
                }}
                value={new Date(data?.startDate)}
                minDate={
                  isDayDisabled()
                    ? isDayDisabled()
                    : differenceInCalendarDays(
                      getFormatedDate(sessionData?.startDate),
                      new Date()
                    ) > 0
                      ? getFormatedDate(sessionData?.startDate)
                      : new Date()
                }
                maxDate={getFormatedDate(sessionData?.endDate)}
              />
              <span className="error-msg mt-1">{error?.startDate}</span>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col lg={6} className="text-start">
            <Button
              onClick={handleHome}
              type="button"
              bname="Cancel"
              name="cancel"
              id="cancel"
              className="btn btn-light rounded-1"
            ></Button>
          </Col>
          <Col lg={6} className="text-end">
            <Button
              onClick={handleNext}
              type="button"
              bname="Continue"
              name="continue"
              id="continue"
              className="btn btn-primary rounded-1"
            ></Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export { CustomerCoachingBookingStep2 };
